module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-28.24ff2c67.png";